import { createRoot } from "react-dom/client";
// Brand typefaces, bundled with the app (no outside font service).
import "@fontsource/cormorant-garamond/400.css";
import "@fontsource/cormorant-garamond/400-italic.css";
import "@fontsource/cormorant-garamond/500.css";
import "@fontsource/cormorant-garamond/500-italic.css";
import "@fontsource/cormorant-garamond/600.css";
import "@fontsource/eb-garamond/400.css";
import "@fontsource/eb-garamond/400-italic.css";
import "@fontsource/eb-garamond/500.css";
import "@fontsource/courier-prime/400.css";
import "@fontsource/courier-prime/700.css";
import "./styles.css";
import { App } from "./dashboard.jsx";
import { isCloud } from "./lib/supabase.js";
import { AuthGate } from "./screens/AuthGate.jsx";
import { AcceptInvite } from "./screens/AcceptInvite.jsx";
import { ResetPassword } from "./screens/ResetPassword.jsx";
import { PublicIntake } from "./screens/PublicIntake.jsx";
import { PublicPortal } from "./screens/PublicPortal.jsx";
import { Privacy } from "./screens/Privacy.jsx";
import { Message } from "./screens/common.jsx";

function route() {
  const parts = location.pathname.replace(/\/+$/, "").split("/").filter(Boolean);
  const [first, second] = parts;
  if (first === "privacy") return <Privacy />;
  if (first === "intake") return isCloud ? <PublicIntake token={second || null} /> : <Message title="Intake form" body="The shareable intake form works in the hosted app. In this browser-only copy, use “Share intake form” inside the dashboard." />;
  if (first === "portal") return isCloud && second ? <PublicPortal token={second} /> : <Message title="Portal link" body="This portal link isn't valid. Ask your planner for a new one." />;
  if (first === "accept") return isCloud && second ? <AcceptInvite token={second} /> : <Message title="Invite" body="This invite link isn't valid." />;
  if (first === "reset") return isCloud ? <ResetPassword /> : <Message title="Reset password" body="Nothing to reset here." />;
  if (!isCloud) return <App />;
  return <AuthGate><App /></AuthGate>;
}

createRoot(document.getElementById("root")).render(route());
